import styles from "./styles.module.scss";
import React from "react";

function ChartNote({ chartNote, className }) {
    return (
        <div className={`${styles.chartNote} ${className}`}>
            <span dangerouslySetInnerHTML={{ __html: chartNote }} />
        </div>
    );
}

export default ChartNote;